import { useState } from "react";
import { Box, ButtonBase, Grid } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { projects } from "../data/projects";
import { Section } from "../ui/primitives";
import { colors } from "../ui/tokens";
import PageHero from "../widgets/PageHero";
import ProjectCard from "../widgets/ProjectCard";
import CtaBand from "../widgets/CtaBand";

const FILTERS = ["all", "product", "client"];

export function OurWork() {
    const { t } = useTranslation("OurWorkPage");
    const [filter, setFilter] = useState("all");
    // "client" covers everything we built rather than sell, private platforms included.
    const shown = projects.filter((p) => filter === "all" || (filter === "product" ? p.kind === "product" : p.kind !== "product"));

    return (
        <>
            <Helmet>
                <title>{t("meta.title")}</title>
                <meta name="description" content={t("meta.description")} data-rh="true" />
                <link rel="canonical" href="https://oxide-digital.com/ourwork" />
            </Helmet>
            <PageHero eyebrow={t("hero.eyebrow")} title={t("hero.title")} lead={t("hero.lead")} />
            <Section tone="paper" py={{ xs: 6, md: 9 }}>
                <Box role="tablist" sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: { xs: 5, md: 7 } }}>
                    {FILTERS.map((f) => (
                        <ButtonBase
                            key={f}
                            role="tab"
                            aria-selected={filter === f}
                            onClick={() => setFilter(f)}
                            sx={{
                                px: 2,
                                py: 1,
                                borderRadius: "999px",
                                fontSize: "0.92rem",
                                fontWeight: 600,
                                border: `1px solid ${filter === f ? colors.ink : colors.line}`,
                                backgroundColor: filter === f ? colors.ink : "transparent",
                                color: filter === f ? colors.onDark : colors.body,
                                "&:hover": { borderColor: colors.ink },
                            }}
                        >
                            {t(`filters.${f}`)}
                        </ButtonBase>
                    ))}
                </Box>
                <Grid container spacing={{ xs: 6, md: 5 }} rowSpacing={{ xs: 7, md: 9 }}>
                    {shown.map((project) => (
                        <Grid item xs={12} sm={6} key={project.id}>
                            <ProjectCard project={project} />
                        </Grid>
                    ))}
                </Grid>
            </Section>
            <CtaBand />
        </>
    );
}
